// Résout un paramètre défini au niveau agence, avec repli sur la valeur globale.
// L'API construit déjà `fh_settings[funeralHomeId]` avec le repli sur la société
// mère, donc le second repli ne sert qu'aux cas où l'agence est absente de la
// carte (agence créée alors que le cache des métadonnées n'a pas encore tourné).
export function getFuneralHomeSettingValue(
  funeralHomeId,
  settingKey,
  initialMetadata
) {
  if (!initialMetadata) {
    return null
  }

  const funeralHomeValue = funeralHomeId
    ? initialMetadata.fh_settings?.[funeralHomeId]?.[settingKey]
    : null

  return funeralHomeValue ?? initialMetadata.settings?.[settingKey] ?? null
}

export default {
  // Obtient la valeur de paramètre en fonction de l'identifiant de la maison funéraire (funeralHomeId) et de la clé du paramètre (settingKey).
  // Si les métadonnées initiales (initialMetadata) ou les paramètres ne sont pas définis, retourne null (ou fournit une valeur par défaut ou génère une erreur).
  getSettingValue(funeralHomeId, settingKey, initialMetadata) {
    if (!initialMetadata || !initialMetadata.settings) {
      return null // ou fournir une valeur par défaut ou générer une erreur
    }

    if (funeralHomeId && initialMetadata.settings.event_settings_to_fh) {
      return initialMetadata.fh_settings?.[funeralHomeId]?.[settingKey] ?? null
    }

    return initialMetadata.settings?.[settingKey] ?? null
  },

  // Tous les paramètres qui pilotent les évènements d'un dossier : ceux de la maison funéraire quand les
  // paramètres d'évènements sont définis par agence, ceux du tenant sinon (même règle que getSettingValue).
  getEventSettings(funeralHomeId, initialMetadata) {
    if (funeralHomeId && initialMetadata?.settings?.event_settings_to_fh) {
      return initialMetadata.fh_settings?.[funeralHomeId] ?? {}
    }

    return initialMetadata?.settings ?? {}
  },

  getFuneralHomeSettingValue
}
